/*
  This component is meant to be used in conjunction with other Foundation dropdowns,
  such as in our Staff Panel filtering.
*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import DateTimeInput from './DateTimeInput';

export default class DateRangeInputDropdown extends Component {
  static propTypes = {
    triggerClassName: PropTypes.string,
    currentItemText: PropTypes.string,
    beginName: PropTypes.string,
    endName: PropTypes.string,
    beginValue: PropTypes.string,
    endValue: PropTypes.string,
    timezone: PropTypes.string,
    initialView: PropTypes.string,
    format: PropTypes.string,
  }

  static defaultProps = {
    triggerClassName: '',
    currentItemText: '',
    beginValue: '',
    endValue: '',
    initialView: 'month',
    beginName: 'date_start',
    endName: 'date_end',
    timezone: moment.tz.guess(),
    format: 'YYYY-MM-DD',
  }

  componentDidMount() {
    this.unlisten = router.listen(() => {
      window.location.reload();
    });
  }

  handleClear = (e) => {
    e.preventDefault();

    // We remove any date query params already present
    let search = qs.parse(location.search.slice(1));
    delete search.date_start;
    delete search.date_end;
    search = qs.stringify(search);

    router.push({ location: window.location, search });
  }

  renderDateTimeInputRow = (style, name, value, props, label) => (
    <div className="u-flex" style={style}>
      <div className="u-w-1/6 u-m-2">
        {label}
      </div>
      <div className="u-w-5/6">
        <DateTimeInput
          name={name}
          defaultValue={value}
          {...props}
        />
      </div>
    </div>
  )

  render() {
    const dateTimeProps = {
      time: false,
      triggerEvents: true,
      useTimezone: this.props.timezone,
      initialView: this.props.initialView,
      hiddenFieldFormat: this.props.format,
    };

    // Styling each row individually allows us to vertically center the
    // To/From labels, as well as ensure the borders stay aligned/run the
    // length of the entire row.

    const firstRowStyle = {
      display: 'flex',
      alignItems: 'center',
    };
    const secondRowStyle = Object.assign({}, firstRowStyle, {
      borderTop: '1px solid #999999',
      position: 'relative',
      top: '-1px',
    });
    const thirdRowStyle = Object.assign({}, secondRowStyle, { top: '-2px' });

    return (
      <Dropdown className="u-relative u-w-full">
        <DropdownTrigger>
          <div className={`u-mr-5 u-relative ${this.props.triggerClassName}`}>
            { this.props.currentItemText }
          </div>
        </DropdownTrigger>

        <DropdownContent
          className="dropdown-content u-overflow-visible">
          {this.renderDateTimeInputRow(firstRowStyle, this.props.beginName, this.props.beginValue, dateTimeProps, 'From:')}
          {this.renderDateTimeInputRow(secondRowStyle, this.props.endName, this.props.endValue, dateTimeProps, 'To:')}
          <div className="u-flex" style={thirdRowStyle}>
            <div className="u-w-1/2">
              <button
                className="Button Button--link u-w-full u-m-0"
                style={{ borderRight: 'solid 1px grey' }}
                onClick={this.handleClear}
              >
                Clear
              </button>
            </div>
            <div className="u-w-1/2">
              <button className="Button Button--link u-w-full u-m-0">
                Go
              </button>
            </div>
          </div>
        </DropdownContent>
      </Dropdown>
    );
  }
}
